import { CardView, Table } from '@mint-lib/icons';
import { ToggleGroup, ToggleGroupItem } from '@mint-lib/tw-components';

import type { FileSystemViewType } from '../../../../types/rag.js';

type Props = {
  view: FileSystemViewType;
  setView: (view: FileSystemViewType) => void;
};

const FileSystemViewSwitcher = ({ view, setView }: Props) => {
  return (
    <ToggleGroup
      value={view}
      onValueChange={(value: 'table' | 'tiles') => {
        //FYI: Radix ToggleGroup deselects on second click, so value='' can broke
        if (!value) return;

        setView(value);
      }}
      className="self-start"
      type="single"
    >
      <ToggleGroupItem value="table" aria-label="table-view">
        <Table />
      </ToggleGroupItem>
      <ToggleGroupItem value="tiles" aria-label="tiles-view">
        <CardView />
      </ToggleGroupItem>
    </ToggleGroup>
  );
};

export { FileSystemViewSwitcher };
